<template>
  <SidePanel
    :hiding="true"
    :show-side-panel="showSidePanel"
    :width="width"
    :height="height"
    @close="$emit('close')"
  >
    <div class="help-popup-container">
      <h2 class="help-popup-title text-center">BESOIN D'AIDE ?</h2>
      <div
        v-if="selectedPartner === null"
        class="text-gray translate"
      >
        <p class="support-text">
          Notre support technique est à votre disposition pour vous assister
          durant cette étape.
        </p>
        <p class="callback-text">
          Je souhaite être
          <span
            class="clickable text-blue"
            @click="recallNow"
          >
            rappelé maintenant</span
          >.
        </p>
        <p class="callback-text">Je réserve un créneau à un autre moment :</p>
      </div>
      <div
        v-else-if="
          selectedPartner.internal_name === 'acd' ||
          selectedPartner.internal_name === 'rca'
        "
        class="text-gray"
      >
        <p>
          <span class="translate"> Vous trouverez un tutoriel détaillé </span>
          <a
            class="clickable text-blue"
            target="_blank"
            :href="
              selectedPartner.internal_name === 'acd'
                ? 'https://help.fygr.io/articles/8831664'
                : 'https://help.fygr.io/articles/8832714'
            "
          >
            <span class="translate" />
            ici </a
          >.
        </p>
        <p>
          <span class="translate">
            Notre support technique est à votre disposition pour vous assister
            durant cette étape.
          </span>
        </p>
        <p>
          <span class="translate"> Je souhaite être </span>
          <span
            class="clickable text-blue translate"
            @click="recallNow"
          >
            rappelé maintenant
          </span>
          ou je réserver un créneau à un autre moment :
        </p>
      </div>
      <div class="iframe-wrapper">
        <iframe
          id="hubspot-iframe"
          class="help-iframe"
          frameborder="0"
          title="J'ai besoin d'aide"
          src="https://meetings.hubspot.com/alexia-dahan/round-robin-sales"
        />
      </div>
    </div>
  </SidePanel>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import SidePanel from './SidePanel.vue';

export default {
  name: 'SideHelpComponent',
  components: {
    SidePanel,
  },
  props: {
    showSidePanel: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: '',
    },
  },
  emits: ['close'],
  data() {
    return {
      keydown: () => true,
    };
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapState('partner', ['selectedPartner']),
  },
  mounted() {
    // add iframe and its contents whenever this component gets mounted
    const iframe = document.getElementById('hubspot-iframe');
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src =
      'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
    iframe.appendChild(script);
  },
  methods: {
    ...mapActions('app', ['actionAddNotification']),
    ...mapActions('tracking', ['actionUpdateHubSpotObject']),
    async recallNow() {
      const company = localStorage.getItem('FYGR_COMPANY');
      const res = await this.actionUpdateHubSpotObject({
        companyId: company,
        HSObj: {
          type: 'contact',
          properties: {
            last_callback_request: 'Require assistance about an integration',
          },
        },
      });
      if (res && !res.error) {
        this.actionAddNotification({
          msg: 'Notre équipe vous rappellera dans les plus brefs délais.',
          color: 'green',
          disappearing: true,
          once: true,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.help-popup-container {
  height: 100%;
  color: $text-color;
  padding-right: var(--px30);
  padding-left: var(--px30);
  @media only screen and (max-width: 500px) {
    padding-right: var(--px15);
    padding-left: var(--px15);
  }
  @media only screen and (max-width: 420px) {
    padding-right: var(--px20);
    padding-left: var(--px20);
  }
  .help-popup-title {
    margin: var(--px30) 0;
    text-transform: uppercase;
    @extend %text-font-demibold;
  }
  .callback-text {
    margin-top: var(--px20);
    margin-bottom: var(--px30);
  }
  .iframe-wrapper {
    height: 100%;
    .help-iframe {
      width: 100%;
      height: 100%;
      overflow-y: hidden;
    }
  }
  @media only screen and (max-width: 420px) {
    .iframe-wrapper {
      padding-right: var(--px15);
      padding-left: var(--px15);
    }
    .clickable {
      font-size: var(--px16);
    }
    .support-text,
    .callback-text {
      font-style: normal;
      font-size: var(--px16);
      line-height: var(--px22);
      color: #000000;
    }
    .help-popup-title {
      font-size: var(--px20);
      line-height: var(--px22);
    }
  }
}
</style>
